import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { withTranslation } from 'react-i18next'
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography, LinearProgress, Grid, AppBar, IconButton, DialogActions } from '@material-ui/core'
import GetAppIcon from '@material-ui/icons/GetApp'
import { ValidatorForm } from 'react-material-ui-form-validator'


function Modal({ t, open, title, onSubmit, onCancel, submitButtonTitle, cancelButtonTitle, contentClassName, submitButtonDisabled, loading, children, onDownload, ...props }) {
    const submitTitle = submitButtonTitle || t('save')
    const cancelTitle = cancelButtonTitle || t('cancel')
    const classes = useStyles()

    return (
        <Dialog open={open} fullWidth maxWidth="xs" aria-labelledby="dialog" {...props}>
            {loading && <LinearProgress className={classes.linearProgress} />}


            <ValidatorForm onSubmit={onSubmit}>
                <DialogContent>

                    <AppBar position="sticky">
                        <DialogTitle id="dialog-title" disableTypography className={classes.dialogTitle}>
                            <Typography component="h3">
                                {title}
                            </Typography>
                        </DialogTitle>
                    </AppBar>
                    <Grid className={[classes.dialogContent, contentClassName]}>
                        {children}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Box style={{ display: 'flex', flex: 1 }}>
                        {onCancel &&
                            <Button onClick={onCancel} disabled={loading} color="primary" className={classes.button}>
                                {cancelTitle}
                            </Button>
                        }
                    </Box>
                    <Box>
                        {
                            onDownload &&
                            <IconButton aria-label="download" onClick={onDownload}>
                                <GetAppIcon />
                            </IconButton>
                        }
                        {onSubmit &&
                            <Button type="submit" disabled={loading || submitButtonDisabled} color="primary" variant="contained" className={classes.button} >
                                {submitTitle}
                            </Button>
                        }
                    </Box>
                </DialogActions>
            </ValidatorForm>

        </Dialog>
    )
}

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.margin.extraSmall
    },
    dialogContent: {
        position: 'relative',
    },
    linearProgress: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 9999
    },
}))

export default (withTranslation()(Modal))